import { Link } from 'react-router-dom';

import { BoxIcon, Spacing, Text } from '#atoms';

import { PortfolioItem } from '#organisims/PortfolioItem';

import { EmptyMessageBox } from '#molecules/EmptyMessageBox';

import {
  ClinicalDataContainer,
  LabelBox
} from '#templates/CoachDetailContent/DetailInfo/CoachIntroduce/styles';

const Portfolio = ({
  clinicalDataList
}: {
  clinicalDataList?: {
    id: number;
    title: string;
    age: number;
    sex: string;
    criteria: string;
    beforeImages: string;
    afterImages: string;
    afters: { resizedLink: string }[];
    befores: { resizedLink: string }[];
  }[];
}) => {
  return (
    <ClinicalDataContainer>
      <LabelBox>
        <Text textStyle="t3">트레이닝 성과</Text>
        <Link to="/profile/portfolio">
          <BoxIcon type="next-arrow" onlyIcon size={14} />
        </Link>
      </LabelBox>
      <Spacing size={20} />
      {clinicalDataList && clinicalDataList.length > 0 ? (
        <PortfolioItem data={clinicalDataList} />
      ) : (
        <EmptyMessageBox>등록된 트레이닝 성과가 없습니다.</EmptyMessageBox>
      )}
    </ClinicalDataContainer>
  );
};

export default Portfolio;
